import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import { ApiLoading } from './ApiLoading'

interface ApiLoadingIndicatorProps {
  marginTop?: number
}
export const ApiLoadingIndicator: React.FC<ApiLoadingIndicatorProps> = (props) => {
  const isFetching = useIsFetching()
  const isMutating = useIsMutating()

  return isFetching || isMutating ? <ApiLoading {...props} /> : null
}
